module.exports = __webpack_public_path__ + "f6a4482563f2dc8bed3529da9b563be3.jpg";